import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgentModelProvider } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { emptyAuthFor } from "aiagent/providerAuth";
const useModelProviderMutations = () => {
  const queryClient = useQueryClient();
  const toCredentialsArg = (credentials) => {
    var _a;
    return {
      provider: credentials.provider,
      auth: (_a = credentials.auth) != null ? _a : emptyAuthFor(credentials.provider)
    };
  };
  const toSaveArg = (config) => {
    var _a;
    return {
      providers: config.providers.map(toCredentialsArg),
      default_provider: config.default_provider,
      default_model_id: (_a = config.default_model_id) != null ? _a : ""
    };
  };
  const save = useMutation({
    mutationFn: (config) => AIAgentModelProvider.saveConfig(toSaveArg(config)),
    onSuccess: () => {
      UserNotification.success("Model provider configuration saved.");
      queryClient.invalidateQueries({ queryKey: ["ai-model-provider-config"] });
    },
    onError: (error) => UserNotification.error(`Saving configuration failed: ${error}`)
  });
  const test = useMutation({
    mutationFn: (body) => AIAgentModelProvider.test({
      provider: body.provider,
      model_id: body.model_id,
      credentials: toCredentialsArg(body.credentials)
    })
  });
  const remove = useMutation({
    mutationFn: () => AIAgentModelProvider.deleteConfig(),
    onSuccess: () => {
      UserNotification.success("Model provider configuration deleted.");
      queryClient.invalidateQueries({ queryKey: ["ai-model-provider-config"] });
    },
    onError: (error) => UserNotification.error(`Deleting configuration failed: ${error}`)
  });
  return { save, test, remove };
};
export default useModelProviderMutations;
